var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output } from '@angular/core';
import { FileComponent } from '../../../../items/columns/file/file.component';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { ConfigService } from '../../../../service/config.service';
import { ApiService } from '../../../../service/api.service';
import { FileService } from '../../../../items/columns/file/file.service';
import { ColumnBaseService } from '../../../../items/columns/base/columnbase.service';
import { LoadingService } from '../../../../component/loading/loading.service';
var KtsMultiUploadFileComponent = /** @class */ (function (_super) {
    __extends(KtsMultiUploadFileComponent, _super);
    function KtsMultiUploadFileComponent(service, baseService, fileService, config, api, loadingService) {
        var _this = _super.call(this, service, baseService, fileService, config, api, loadingService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.fileService = fileService;
        _this.config = config;
        _this.api = api;
        _this.loadingService = loadingService;
        _this.changeFile = new EventEmitter();
        return _this;
    }
    KtsMultiUploadFileComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsMultiUploadFileComponent.prototype.setDropzone = function () {
        var acceptedFiles = jsonpath.value(this.col, '$.params.options.acceptedFiles') || 'image/*';
        acceptedFiles = (acceptedFiles === '*' ? null : acceptedFiles);
        var maxFilesize = jsonpath.value(this.col, '$.params.options.maxFilesize');
        this.element = this.fileElement.nativeElement;
        var self = this;
        $(this.element).dropzone({
            url: this.host + "/upload",
            headers: this.api.getCsrfToken(),
            paramName: 'file',
            acceptedFiles: acceptedFiles,
            maxFilesize: maxFilesize ? maxFilesize : 1,
            addRemoveLinks: true,
            withCredentials: true,
            dictInvalidFileType: self.msg['au.COMPONENT.FileComponent.label.invalidFileType'],
            dictRemoveFile: self.msg['au.COMPONENT.FileComponent.label.removeFile'],
            params: {
                uploadType: jsonpath.value(self.col, '$.params.uploadType') || null
            },
            init: function () {
                this.on('addedfile', function (file) {
                    self.loadingService.on();
                });
                this.on('complete', function (file) {
                    self.loadingService.off();
                });
            },
            success: function (file, responseText, e) {
                if (responseText.url) {
                    if (responseText.url && responseText.url.match(/(.+\/)(.+?)$/)) {
                        self.path = RegExp.$1;
                        self.uploadFileName = RegExp.$2;
                    }
                    self.fileName = self.uploadFileKey ? file.name : self.uploadFileName;
                }
                self.onChange();
                this.removeFile(file);
            },
            error: function (file, message) {
                if (file.xhr && file.xhr.status === 401) {
                    self.api.onUnauthorized(message);
                }
                if (file.previewElement) {
                    file.previewElement.classList.add('dz-error');
                    file.previewElement.querySelector('.dz-error-message').style['white-space'] = 'pre-wrap';
                    file.previewElement.querySelector('.dz-error-message').style['top'] = '140px';
                    if (typeof message !== 'string' && message.message) {
                        message = message.message;
                    }
                    file.previewElement.querySelector('[data-dz-errormessage]').textContent = message;
                }
            }
        });
    };
    KtsMultiUploadFileComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.index && !changes.index.firstChange) {
            this.selectType = jsonpath.value(this.col, '$.params.fileName.selectType') || false;
            this.type = jsonpath.value(this.col, '$.params.fileName.type') || "auto" /* auto */;
            this.nameTypeKey = jsonpath.value(this.col, '$.params.fileName.nameTypeKey') || null;
            this.uploadFileKey = jsonpath.value(this.col, '$.params.fileName.uploadFileKey') || null;
            this.displayFileKey = jsonpath.value(this.col, '$.params.fileName.displayFileKey') || null;
        }
    };
    KtsMultiUploadFileComponent.prototype.onChange = function () {
        _super.prototype.onChange.call(this);
        var data = {};
        data[this.col.key] = this.path + (this.type === "auto" /* auto */ ? this.uploadFileName : this.fileName);
        if (!this.col.readonly) {
            if (this.nameTypeKey) {
                data[this.nameTypeKey] = this.type;
            }
            if (this.uploadFileKey) {
                data[this.uploadFileKey] = this.uploadFileName;
            }
            if (this.displayFileKey) {
                data[this.displayFileKey] = this.displayFileName;
            }
        }
        this.changeFile.emit(data);
    };
    KtsMultiUploadFileComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-multi-upload-file',
                    template: "\n        <div class=\"dropzone dz-clickable\" #file>\n            <div class=\"dz-default dz-message\">{{ msg['au.COMPONENT.FileComponent.label.message'] }}</div>\n        </div>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsMultiUploadFileComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: FileService },
        { type: ConfigService },
        { type: ApiService },
        { type: LoadingService }
    ]; };
    KtsMultiUploadFileComponent.propDecorators = {
        changeFile: [{ type: Output }]
    };
    return KtsMultiUploadFileComponent;
}(FileComponent));
export { KtsMultiUploadFileComponent };
//# sourceMappingURL=multi-upload-file.component.js.map